import { createSignal, createEffect } from 'solid-js';
import dayjs from 'dayjs';

const useGlobalTime = () => {
  const [globalTime, setGlobalTime] = createSignal(null);
  return { globalTime, setGlobalTime };
};

const useGlobalContext = () => {
  const [globalContext, setGlobalContext] = createSignal(null);
  return { globalContext, setGlobalContext };
};

const useTimer = () => {
  const [timer, setTimer] = createSignal(0);
  const [intervalTime, setIntervalTime] = createSignal(600);
  createEffect(() => {
    if (intervalTime) {
      const interval = setInterval(
        () => setTimer((_timer) => _timer + intervalTime()),
        intervalTime() * 1000,
      );
      return () => clearInterval(interval);
    }
  }, [intervalTime]);
  return { timer, setIntervalTime };
};

export { useGlobalContext, useGlobalTime, useTimer };
